export async function slotIndexUseCase(slotRepository) {
    const result = await slotRepository.index();

    result.forEach(x => {
        x = new slotRepository.model(x);

        if (!x.isValid()) {
            throw new Error("slot inválido");
        }
    })

    return result;
}